import { useBuy } from "@/context/buy";
import { useRouter } from "next/router";
import { useState } from "react";
import toast from "react-hot-toast";
import { motion } from "framer-motion";

export default function ForgotPasswordModal({ setForgotModalOpen }) {
    const router = useRouter();
    const { setOpenModal } = useBuy();
    const [email, setEmail] = useState("");

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Please enter your email");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("email", email);
            formData.append("action", "passwordReset");
            const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

            const response = await fetch(`${BACKEND_URL}/webapi/manageUser`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (data.status) {
                toast.success(data.message || "Reset email sent");
                router.push("/")
            } else {
                toast.error(data.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("Server error");
            console.error("Forgot password error:", error);
        }
    };

    return (
        <div id="LoginModal" className="bg-gray-800 relative z-[99999]">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="flex flex-col md:flex-row justify-start lg:items-center lg:justify-center fixed overflow-y-auto h-full inset-0 px-6 md:px-0 bg-gray-700/50 z-[999]"
                onClick={() => setForgotModalOpen(false)}
            >
                <div className="md:hidden" onClick={(e) => e.stopPropagation()}>
                    <div className="flex justify-end mt-3 -mr-5">
                        <div
                            onClick={() => setOpenModal((prev) => ({ ...prev, otp: false }))}
                            className="w-10 h-10 rounded-full bg-[#1F222A] flex items-center justify-center mb-2"
                        >
                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.144 12L5.496 5.352V6.552L0.456 0.287999H3.288L6.864 4.848H6L9.576 0.287999H12.408L7.368 6.504V5.424L12.72 12H9.84L6 7.152H6.816L3 12H0.144Z"
                                    fill="#6A798F"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleResetPassword} className="mt-5 pl-2 lg:pl-0 lg:mt-7">
                    <div
                        className="bg-[#17191d] h-fit w-full max-w-[620px] overflow-hidden md:my-[20px] overflow-y-auto px-4 lg:px-[40px] pb-[40px] rounded-[16px] lg:rounded-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="mt-6 lg:mt-0 lg:px-4">
                            <div className="lg:mt-11">
                                <p className="py-3 pl-2 text-base lg:text-xl max-w-[600px] mx-auto">
                                    Forgot Password
                                </p>
                            </div>
                            <div className="lg:mt-6 mb-[80px] lg:mb-[150px] max-w-[600] mx-auto">
                                <p className="text-start">
                                    Enter your email address and we’ll send you a reset link
                                </p>
                                <div className="mt-[50px] lg:mt-[80px] flex justify-center">
                                    <input
                                        type="email"
                                        placeholder="Email address"
                                        className="text-xs lg:text-[20px] bg-transparent p-4 border border-[#35383F] rounded-[8px] lg:rounded-[16px] focus:outline-1 focus:outline-[#FA2CB4] focus:bg-[#E74CF414] focus:border-none px-6 w-full max-w-md"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="mt-5 lg:mt-12 pt-1 relative">
                                <div className="absolute w-[120%] left-[-10%]">
                                    <svg width="100%" height="2" viewBox="0 0 694 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="1" x2="694.001" y2="1" stroke="#332D41" />
                                    </svg>
                                </div>
                            </div>
                            <div className="mt-5 lg:mt-3 modal-footer flex flex-col lg:flex-row gap-4 lg:gap-8 items-center justify-end">
                                <button
                                    type="submit"
                                    className="main_btn_bg font-urbanist lg:order-2 font-[800] text-[14px] lg:text-base py-[6px] lg:py-5 px-[62px] w-[179px] lg:w-[340px] rounded-[10px] lg:leading-[10px]"
                                >
                                    Continue
                                </button>
                                <button
                                    onClick={() => setForgotModalOpen(false)}
                                    className="border-[#35383F] hidden lg:block bg-[#6b6b6b17] font-urbanist font-[500] border text-[14px] lg:text-base py-[6px] lg:py-[19px] lg:leading-[10px] px-[62px] w-[179px] lg:w-[340px] rounded-[10px]"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </motion.div >
        </div >
    );
}
